import {
  CHANGE_EXCLUDE_FILTER,
  CHANGE_MODAL_SEARCH,
  CHANGE_MSP_PARTICIPANTS_MODAL_PAGE,
  CHANGE_PARTICIPANTS_MODAL_PAGE,
  CHANGE_PARTICIPANTS_SELECTION,
  CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  CHANGE_SELECTION_DATA,
  CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  FETCH_AUTONOMOUS_SCHEDULE_ASYNC,
  FETCH_PARTICIPANTS_DATA_ASYNC,
  GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC,
  GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC,
  GET_PARTICIPANTS_ASYNC,
  GET_PARTICIPANTS_INFO_ASYNC,
  SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC,
  SEARCH_PARTICIPANTS_INFO_ASYNC,
  SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC,
  UPDATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  UPDATE_PARTICIPANTS_NUMBERS_ASYNC,
} from './constants'

export const fetchAutonomousSchedule = () => ({
  type: FETCH_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE,
})
export const fetchAutonomousScheduleSuccess = (data) => ({
  type: FETCH_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAutonomousScheduleError = (error) => ({
  type: FETCH_AUTONOMOUS_SCHEDULE_ASYNC.ERROR,
  error,
})
const fetchAutonomousScheduleCancel = () => ({
  type: FETCH_AUTONOMOUS_SCHEDULE_ASYNC.CANCEL,
})

const getGroupAutonomousSchedule = () => ({
  type: GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE,
})
export const getGroupAutonomousScheduleSuccess = (data) => ({
  type: GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS,
  payload: { data },
})
export const getGroupAutonomousScheduleError = (error) => ({
  type: GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.ERROR,
  error,
})
const getGroupAutonomousScheduleCancel = () => ({
  type: GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.CANCEL,
})

export const getGroupAutonomousConfigMember = () => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.INITIATE,
})
export const getGroupAutonomousConfigMemberSuccess = (data) => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS,
  payload: { data },
})
export const getGroupAutonomousConfigMemberError = (error) => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR,
  error,
})
const getGroupAutonomousConfigMemberCancel = () => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.CANCEL,
})

export const getGroupAutonomousConfigMemberCandidates = () => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.INITIATE,
})
export const getGroupAutonomousConfigMemberCandidatesSuccess = (data) => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.SUCCESS,
  payload: { data },
})
export const getGroupAutonomousConfigMemberCandidatesError = (error) => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.ERROR,
  error,
})
const getGroupAutonomousConfigMemberCandidatesCancel = () => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.CANCEL,
})

const createGroupAutonomousConfigMember = (companyId) => ({
  type: CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.INITIATE,
  payload: { companyId },
})
export const createGroupAutonomousConfigMemberSuccess = (data) => ({
  type: CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS,
  payload: { data },
})
export const createGroupAutonomousConfigMemberError = (error) => ({
  type: CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR,
  error,
})
const createGroupAutonomousConfigMemberCancel = () => ({
  type: CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.CANCEL,
})

const deleteGroupAutonomousConfigMember = (companyId) => ({
  type: DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.INITIATE,
  payload: { companyId },
})
export const deleteGroupAutonomousConfigMemberSuccess = (data) => ({
  type: DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS,
  payload: { data },
})
export const deleteGroupAutonomousConfigMemberError = (error) => ({
  type: DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR,
  error,
})
const deleteGroupAutonomousConfigMemberCancel = () => ({
  type: DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.CANCEL,
})

const updateGroupAutonomousConfigMember = (companyId, data) => ({
  type: UPDATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.INITIATE,
  payload: { companyId, data },
})
export const updateGroupAutonomousConfigMemberSuccess = (data) => ({
  type: UPDATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS,
  payload: { data },
})
export const updateGroupAutonomousConfigMemberError = (error) => ({
  type: UPDATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR,
  error,
})
const updateGroupAutonomousConfigMemberCancel = () => ({
  type: UPDATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.CANCEL,
})

const updateParticipantsNumbers = () => ({
  type: UPDATE_PARTICIPANTS_NUMBERS_ASYNC.INITIATE,
})
export const updateParticipantsNumbersSuccess = (data) => ({
  type: UPDATE_PARTICIPANTS_NUMBERS_ASYNC.SUCCESS,
  payload: { data },
})
export const updateParticipantsNumbersError = (error) => ({
  type: UPDATE_PARTICIPANTS_NUMBERS_ASYNC.ERROR,
  error,
})
const updateParticipantsNumbersCancel = () => ({
  type: UPDATE_PARTICIPANTS_NUMBERS_ASYNC.CANCEL,
})

const saveGroupAutonomousSchedule = (months, forceSave, allItems, excludeIds) => ({
  type: SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE,
  payload: { months, forceSave, allItems, excludeIds },
})
export const saveGroupAutonomousScheduleSuccess = () => ({
  type: SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS,
})
export const saveGroupAutonomousScheduleError = (data) => ({
  type: SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.ERROR,
  payload: { data },
})
const saveGroupAutonomousScheduleCancel = () => ({
  type: SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.CANCEL,
})

const submitAutonomousSchedule = (months) => ({
  type: SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE,
  payload: { months },
})
export const submitAutonomousScheduleSuccess = (res, months) => ({
  type: SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS,
  payload: { months },
})
export const submitAutonomousScheduleError = (error) => ({
  type: SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.ERROR,
  error,
})
const submitAutonomousScheduleCancel = () => ({
  type: SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.CANCEL,
})

const getParticipantsInfo = (companyId, index) => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.INITIATE,
  payload: { companyId, index },
})
export const getParticipantsInfoSuccess = (data, index) => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.SUCCESS,
  payload: { data, index },
})
export const getParticipantsInfoError = (error) => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.ERROR,
  error,
})
const getParticipantsInfoCancel = () => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.CANCEL,
})

const searchParticipantsInfo = (value, companyId, index) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.INITIATE,
  payload: { value, companyId, index },
})
export const searchParticipantsInfoSuccess = (data, index) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.SUCCESS,
  payload: { data, index },
})
export const searchParticipantsInfoError = (error) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.ERROR,
  error,
})
const searchParticipantsInfoCancel = () => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.CANCEL,
})

export const fetchParticipantsData = (data) => ({
  // TODO : remove when containers\Settings\Notifications\EndUser\Editor will not have this dependency
  type: FETCH_PARTICIPANTS_DATA_ASYNC.INITIATE,
  payload: { data },
})
export const fetchParticipantsDataSuccess = (data) => ({
  type: FETCH_PARTICIPANTS_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchParticipantsDataError = (error) => ({
  type: FETCH_PARTICIPANTS_DATA_ASYNC.ERROR,
  error,
})
const fetchParticipantsDataCancel = () => ({
  type: FETCH_PARTICIPANTS_DATA_ASYNC.CANCEL,
})

const getParticipants = (companyId) => ({
  type: GET_PARTICIPANTS_ASYNC.INITIATE,
  payload: { companyId },
})
export const getParticipantsSuccess = (data) => ({
  type: GET_PARTICIPANTS_ASYNC.SUCCESS,
  payload: { data },
})
export const getParticipantsError = (error) => ({
  type: GET_PARTICIPANTS_ASYNC.ERROR,
  error,
})
const getParticipantsCancel = () => ({
  type: GET_PARTICIPANTS_ASYNC.CANCEL,
})

const changeParticipantsSelection = (value, key) => ({
  type: CHANGE_PARTICIPANTS_SELECTION,
  payload: { value, key },
})
const changeParticipantsTotalSelection = (data) => ({
  type: CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  payload: { data },
})
const changeExcludeFilter = (value) => ({
  type: CHANGE_EXCLUDE_FILTER,
  payload: { value },
})
const changeModalSearch = (search) => ({
  type: CHANGE_MODAL_SEARCH,
  payload: { search },
})
const changeParticipantsModalPage = (page) => ({
  type: CHANGE_PARTICIPANTS_MODAL_PAGE,
  payload: { page },
})
const changeMspParticipantsModalPage = (page) => ({
  type: CHANGE_MSP_PARTICIPANTS_MODAL_PAGE,
  payload: { page },
})
const changeSelectionData = (field, value) => ({
  type: CHANGE_SELECTION_DATA,
  payload: { field, value },
})

export default {
  // to props
  submitAutonomousSchedule,
  submitAutonomousScheduleCancel,
  getParticipantsInfo,
  getParticipantsInfoCancel,
  fetchParticipantsData,
  fetchParticipantsDataCancel,
  fetchAutonomousScheduleCancel,
  getParticipants,
  getParticipantsCancel,
  changeParticipantsSelection,
  changeParticipantsTotalSelection,
  changeExcludeFilter,
  changeModalSearch,
  changeParticipantsModalPage,
  changeMspParticipantsModalPage,
  changeSelectionData,
  searchParticipantsInfo,
  searchParticipantsInfoCancel,
  getGroupAutonomousSchedule,
  getGroupAutonomousScheduleCancel,
  getGroupAutonomousConfigMember,
  getGroupAutonomousConfigMemberCancel,
  getGroupAutonomousConfigMemberCandidates,
  getGroupAutonomousConfigMemberCandidatesCancel,
  createGroupAutonomousConfigMember,
  createGroupAutonomousConfigMemberCancel,
  deleteGroupAutonomousConfigMember,
  deleteGroupAutonomousConfigMemberCancel,
  updateGroupAutonomousConfigMember,
  updateGroupAutonomousConfigMemberCancel,
  updateParticipantsNumbers,
  updateParticipantsNumbersCancel,
  saveGroupAutonomousSchedule,
  saveGroupAutonomousScheduleCancel,
}
